import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import get from 'lodash/get';
import { colors } from '../../../constants/styleConstants';
import { dateFormats } from '../../../constants/consts';
import Title from '../../Title';

const useStyles = makeStyles(theme => ({
  monthBlock: {
    display: 'flex',
    flexDirection: 'column',
  },
  month: {
    marginBottom: theme.spacing(0.5),
    fontSize: 12,
    fontWeight: 'bold',
    color: colors.black,
    display: 'flex',
    justifyContent: 'flex-start',
  },
  datesBlock: {
    display: 'flex',
    width: '85%',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      width: '70%',
      '& > div:last-child': {
        borderBottom: 'none',
      },
    },
  },
  dates: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  dateCircle: {
    width: 35,
    height: 35,
    borderRadius: '50%',
    position: 'relative',
    backgroundColor: colors.white,
    color: colors.title,
    marginRight: '5px',
    border: 'solid 1px lightgray',
    cursor: 'pointer',
    outline: 'none',
    [theme.breakpoints.down('xs')]: {
      width: 30,
      height: 30,
      fontSize: 10,
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  date: {
    fontSize: 12,
    position: 'absolute',
    top: 13,
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('xs')]: {
      top: '50%',
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  dayOfWeek: {
    fontSize: 8,
    position: 'absolute',
    top: 25,
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  performed: {
    backgroundColor: colors.primary,
    color: colors.white,
  },
  typeLetter: {
    fontSize: 12,
    fontStyle: 'italic',
  },
}));

const PerformedDates = ({ dates, title, onDateClick }) => {
  const classes = useStyles();
  return (
    <div className={classnames(classes.monthBlock)}>
      <div className={classes.month}>
        <Title>{title}</Title>
      </div>
      <div className={classes.dates}>
        {(dates || []).map((date, index) => {
          const momentDate = get(date, 'date');
          const cancelled = get(date, 'cancelled', false);
          const matinee = get(date, 'matinee', false);
          const tour = get(date, 'tour', false);
          const performed = get(date, 'performed', false) && !cancelled;
          return momentDate ? (
            <div
              className={classnames(classes.dateCircle, { [classes.performed]: performed })}
              key={`${momentDate.format(dateFormats.basic)}-${index}`}
              onClick={() => onDateClick(date)}
              role="button"
              tabIndex={0}
              onKeyDown={() => onDateClick(date)}
            >
              <span className={classes.date}>
                {momentDate.format('DD')}
                <span className={classes.typeLetter}>
                  {matinee && 'm'}
                  {tour && 't'}
                </span>
              </span>
              <span className={classes.dayOfWeek}>{momentDate.format('ddd')}</span>
            </div>
          ) : null;
        })}
      </div>
    </div>
  );
};

PerformedDates.propTypes = {
  dates: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  onDateClick: PropTypes.func.isRequired,
};

export default PerformedDates;
